import React from 'react';
import FormDialog from '../form/form-dialog';
import http from '../utils/http';

const ApplicationURIDeleteModal = (props) => {

    const {
        config,
        isOpen,
        onChangeBulk,
        applicationId,
        applicationURIName,
        environmentName
    } = props;
    return (
        <FormDialog
            dialogTitle={`Delete "${applicationURIName} API" Application URI?`}
            dialogSubHeading={'WARNING: Deleting an application URI will prevent that application URI from appearing in the config response from the API and no longer be available for use in code. Are you sure?'}
            submitButtonText={'DELETE'}
            handleClose={() => onChangeBulk({ applicationURIDeleteModalIsOpen: false })}
            handleSubmit={async () => {
                const application = await http.delete(
                    {},
                    `${config.uri.base}/application/${applicationId}/environment/${environmentName}/uri/${applicationURIName}`
                );
                onChangeBulk({
                    applicationURIDeleteModalIsOpen: false,
                    application: application,
                    environments: application.environments,
                });
            }}
            isOpen={isOpen}
        >
        </FormDialog>
    );
};

export default ApplicationURIDeleteModal;
